module.exports = __webpack_public_path__ + "img/Plug & Play Connnectivity.4dc7d887.svg";